import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import QuillEditor from './Editor';

export interface Props<F extends FieldValues> {
    name: Path<F>;
    control: Control<F>;
    maxCharacterCount?: number;
    disabled?: boolean;
    attachments?: File[];
    onFilesAttached?: (files: File[]) => void;
    onRemoveAttachment?: (index: number) => void;
}

const FormTextEditor = <F extends FieldValues>({
    name,
    control,
    maxCharacterCount,
    disabled = false,
    attachments,
    onFilesAttached,
    onRemoveAttachment,
}: Props<F>) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <QuillEditor
                    value={field.value}
                    onChange={field.onChange}
                    error={error}
                    maxCharacterCount={maxCharacterCount}
                    disabled={disabled}
                    attachments={attachments}
                    onFilesAttached={onFilesAttached}
                    onRemoveAttachment={onRemoveAttachment}
                />
            )}
        />
    );
};

export default FormTextEditor;